// extracted by mini-css-extract-plugin
export default {"button":"SettingsButton_button__u136B","arrow":"SettingsButton_arrow__uCoxe"};